<section>
  <div class="laft-company-keynua-qr-modal">
    <p class="laft-company-keynua-qr-modal--title">Valida tu identidad de forma segura</p>
    <p class="laft-company-keynua-qr-modal--description">
      Este paso es necesario para firmar el contrato y la declaración jurada de LAFT. Ten a la mano tu documento de
      identidad.
    </p>

    <!-- QR Code Sections - Can have 1 or 2 based on legal representatives -->
    <div class="laft-company-keynua-qr-modal--qr-sections">
      <div 
        *ngFor="let representative of legalRepresentatives; let i = index" 
        class="laft-company-keynua-qr-modal--qr-section"
      >
        <div class="laft-company-keynua-qr-modal--qr-content">
          <!-- QR Code -->
           <div class="laft-company-keynua-qr-modal--qr-container">
            <div class="laft-company-keynua-qr-modal--qrcode">
              <qrcode [qrdata]="representative.keynuaUrl" [width]="150"></qrcode>
            </div>
            <p *ngIf="isClient" class="laft-company-keynua-qr-modal--caption laft-company-keynua-qr-modal--caption--desktop u-mb-2">
              Escanea el QR para firmar desde tu celular,
              <br />
              el proceso tiende a ser más rápido.
            </p>
          </div>

          <!-- Mobile User Icon -->
          <div class="laft-company-keynua-qr-modal-icon laft-company-keynua-qr-modal-icon--mobile">
            <img src="assets/icons/user-square.svg" alt="User validation" class="laft-company-keynua-qr-modal-icon--image" />
          </div>

          <!-- Representative Info and Actions -->
          <div class="laft-company-keynua-qr-modal--representative-info">
            <p class="laft-company-keynua-qr-modal--representative-name">{{ representative.fullName }}</p>
            <lib-ui-button
              variant="filled"
              size="l"
              [fullWidth]="true"
              (click)="goToKeynua(representative.keynuaUrl)"
              label="Ir a firmar"
            ></lib-ui-button>
            <a 
              class="laft-company-keynua-qr-modal--copy-link" 
              (click)="copyLink(representative.keynuaUrl, $event)"
            >
              Copiar Link
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Information Text -->
    <p *ngIf="!isClient" class="laft-company-keynua-qr-modal--caption laft-company-keynua-qr-modal--caption--desktop u-mb-2">
      El proceso es más fácil y rápido desde tu dispositivo móvil.
    </p>
    <p class="laft-company-keynua-qr-modal--caption">
      Tu información está protegida y solo se usará en este proceso.
    </p>

    <!-- Explore Platform Button -->
    <div class="laft-company-keynua-qr-modal-button-actions">
      <lib-ui-button
        variant="outline"
        size="l"
        [fullWidth]="true"
        (click)="explorePlatform()"
        label="Explorar la plataforma"
      ></lib-ui-button>
    </div>
  </div>
</section>
